import LocalAdConfig from './config/local-ad-config.json';
import ProdAdConfig from './config/prod-ad-config.json';

function getAdConfig() { 
  if (window.location.hostname.indexOf('localhost') > -1) {
    return LocalAdConfig;
  } else if (window.location.hostname.indexOf('apps.unislink') > -1) {
    return ProdAdConfig;
  } 
  return LocalAdConfig;
}

export const AdConfig = getAdConfig();
